import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import UserRegister from "./user-register"
import copy from "../const/homeCopy.json"
import "../css/home.css"

// The logged-out home page (plan B2.5): the sign-up form, unchanged, then
// what Chaperon offers. server/renderHome.js renders the same copy for
// crawlers, so edit homeCopy.json rather than this text.
export default function Home() {
    return (
        <>
            <UserRegister />
            <section className="home-info container" aria-labelledby="home-info-heading">
                <Helmet>
                    <title>{copy.title}</title>
                    <meta name="description" content={copy.description} />
                </Helmet>
                <h2 id="home-info-heading" className="home-info-heading">
                    {copy.heading}
                </h2>
                <p className="home-info-intro">{copy.intro}</p>
                <div className="row g-4">
                    {copy.features.map((feature) => (
                        <div className="col-md-4" key={feature.title}>
                            <div className="home-info-feature h-100">
                                <i className={`bi ${feature.icon}`} aria-hidden="true"></i>
                                <h3>{feature.title}</h3>
                                <p>{feature.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="home-info-links">
                    {copy.loginPrompt} <Link to="/user/login">{copy.loginLabel}</Link>
                    <span aria-hidden="true"> · </span>
                    {copy.learnMorePrefix} <a href={copy.learnMoreUrl}>{copy.learnMoreLabel}</a>
                </p>
            </section>
        </>
    )
}
